import { useChatContext } from '@/pages/chat/context';
import type { ThemeMode } from '@/pages/chat/context';

// 预先 import 浅色图片
import loadingLight from '@/assets/images/loading@2x.png';
import loadingDark from '@/assets/images/dark-loading@2x.png';

import logoLight from '@/assets/images/logo.png';

// 预先 import 深色图片
import logoDark from '@/assets/images/dark-logo@2x.png';

// 尝试 import 深色图片（使用 Vite 的 glob import）
// 深色图片命名规则: dark-{name}.png 或 dark-{name}@2x.png
const darkImages: Record<string, string> = {};

// 使用 Vite 的 ?url import 获取图片路径
// 注意：深色图片需要补充后才能正确加载
// 暂时 fallback 到浅色图片
const imageMap: Record<string, { light: string; dark: string }> = {
  avatar: {
    light: loadingLight,
    dark: loadingDark,
  },
  loading: {
    light: loadingLight,
    dark: loadingDark,
  },
  logo: {
    light: logoLight,
    dark: logoDark,
  },
};

/**
 * 根据当前主题返回对应图片
 * @param name 图片名称
 * @returns 图片路径
 */
export function useThemeImage(name: string): string {
  const { theme } = useChatContext();
  const currentTheme: ThemeMode = theme || 'light';

  const images = imageMap[name];
  if (!images) {
    console.warn(`useThemeImage: 未找到图片 "${name}"`);
    return '';
  }

  return images[currentTheme];
}

/**
 * 导出所有图片路径供非 hook 场景使用
 */
export const themeImages = imageMap;

/**
 * 更新图片映射（用于动态添加深色图片）
 * 在深色图片准备好后调用此函数更新映射
 */
export function updateThemeImage(name: string, darkImage: string) {
  if (imageMap[name]) {
    imageMap[name].dark = darkImage;
  }
}
